(ns ncr.masthead
  (:require
   ["copy-to-clipboard" :as copy-to-clipboard]
   ["source/neckar.svg" :as neckar-logo]
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [uix.core.alpha :as uix]
   [ncr.auth :as a]
   [ncr.amplitude :as amp]
   [ncr.etc.util :as u]
   [ncr.backend]
   [ncr.widgets.core :as w]
   [ncr.me :as me]
   [ncr.cluster :as cluster]
   [ncr.search.cheatsheet :as search.cheatsheet]
   [ncr.etc.reload :as rel]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.nsql :as nsql]
   [ncr.manage.preferences :as preferences]
   [ncr.navigate :as n]
   [ncr.sysinfo]
   [ncr.tour]))

(defn- c-avatar []
  (let [{:keys [name cluster roles id] :as me} (uix/context me/*context*)]
    [pf/c-popover
     {:show-close true
      :position :bottom-end
      :enable-flip false
      :has-auto-width true
      :header-content [:div.pf-u-pl-md name " @ " (:name cluster)]
      :body-content
      (fn [hide]
        (let
          [handler
           (fn [f]
             (fn [_]
               (hide)
               (f)))]

          (uix/as-element
            [pf/l-flex {:direction :column}
             (when u/is-development-environment?
               [:div.pf-u-pl-md
                [:div.pf-u-font-size-xs.pf-u-color-400 (str " " roles)]])

             [pf/c-menu {:is-plain true}
              [pf/c-menu-content
               [pf/c-menu-list
                [pf/c-menu-item
                 {:icon [w/c-mdi-icon {:icon :information-variant}]
                  :on-click (handler #(ps/pub! [:about/open]))}
                 "About"]

                (when (and (preferences/use-experimental?) (= (:slug cluster) "demo"))
                  [pf/c-menu-item
                   {:icon [w/c-mdi-icon {:icon :eiffel-tower}]
                    :on-click (handler #(ncr.tour/start!))}
                   [w/c-with-experimental-label
                    {:label "Application Tour"}]])

                [pf/c-divider]

                [pf/c-menu-item
                 {:icon [w/c-mdi-icon {:icon :cog-outline}]
                  :on-click (handler #(preferences/!edit-preferences))}
                 "Preferences"]

                (when (preferences/use-experimental?)
                  [pf/c-menu-item
                   {:icon [w/c-mdi-icon {:icon :account-cog-outline}]
                    :on-click (handler #(a/account-management!))}
                   [w/c-with-experimental-label {:label "Account Management"}]])

                [pf/c-menu-item
                 {:is-disabled false
                  :on-click
                  (handler
                    #(go (copy-to-clipboard (str "Bearer " (<! (a/token))))))
                  :icon [w/c-mdi-icon {:icon :security}]}
                 "Copy Auth Token (dev)"]

                [pf/c-divider]

                (let [clusters (cluster/use-clusters)]
                  (when (> (count clusters) 1)
                    [:<>
                     [pf/c-menu-item
                      {:icon [w/c-mdi-icon {:icon :swap-horizontal}]
                       :on-click (handler cluster/switch-modal!)}
                      "Switch Cluster"]
                     [pf/c-divider]]))

                [pf/c-menu-item
                 {:icon [w/c-mdi-icon {:icon :logout}]
                  :on-click (handler #(a/signout!))}
                 "Logout"]]]]])))}
     (let [{:keys [name picture]} (me/user-by-id me id)]
       [w/c-avatar
        {:experimental? (preferences/use-experimental?)
         :src picture
         :alt (u/initials name)
         :border :dark
         :style {:cursor :pointer}}])]))

(defn c-search [query]
  (let
    [state
     (rel/use-reload! ::c-page-header
       (ps/sub-reducer-map! ""
         {:query/navigate
          (fn [query]
            (n/push-search! query)
            query)

          :query/toggle
          (fn [query value]
            (let [query (nsql/simple-toggle query value)]
              (n/push-search! query)
              query))}))]

    (uix/with-effect [query]
      (when (some? query)
        (reset! state query)))

    [pf/c-text-input-group {:class :ncr-c-search :data-tour-target :search-input}
     [pf/c-text-input-group-main
      {:icon [pf/c-search-icon]
       :placeholder "Find Documents"
       :value @state

       :on-change
       (fn [_ value]
         (reset! state value))

       :on-key-down
       #(let [key (.-key %)]
          (when (= key "Enter")
            (amp/search! {"Query" @state "Origin" "Masthead Input"})
            (n/push-search! @state)))}]

     [pf/c-text-input-group-utilities
      (when (seq @state)
        [pf/c-button
         {:variant :plain
          :on-click
          (fn [_]
            (amp/search! {"Origin" "Masthead Reset" "Query" ""})
            (n/push-search! ""))}
         [pf/c-times-icon]])

      [search.cheatsheet/cheat-sheet]]]))

(defn c-masthead [{:keys [query]}]
  (let
    [{:keys [cluster]} (uix/context me/*context*)
     cluster-name (:name cluster)]

    (uix/with-effect [cluster-name query]
      (u/set-page-title query cluster-name))

    [:header {:class [:pf-c-page__header :ncr-c-navbar]}
     [:div.pf-c-page__header-brand
      [pf/c-page-toggle-button [pf/c-bars-icon]]
      [:a.pf-c-page__header-brand-link
       {:href
        (n/href :root)
        :on-click
        #(n/push-state! :root)}
       [w/svg {:data neckar-logo :title "Neckar logo"}]
       (when (= (:slug cluster) "demo")
         [pf/c-label
          {:color "cyan"}
          "Demo"])]]

     [:div.pf-u-display-flex.pf-c-page__header-content
      [c-search query]

      [cluster/c-toolbar-switch]
      [c-avatar]]]))
